<template>
    <div class="fullscreen white-skin">

        <!--Intro Section-->
        <mdb-view class="intro-2 fullscreen-view" >
            <mdb-mask overlay="stylish-slight" style="height: 100%; overflow: scroll;">
                <mdb-container class="d-flex justify-content-center align-items-center">
                    <mdb-row class="mt-3 pt-3">
                        <mdb-col md="12">
                            <mdb-card class="mb-5">
                                <mdb-card-body>
                                    <h4
                                            class="font-weight-bold my-4 text-center mb-5 mt-4 font-weight-bold">
                                        <strong>Programme de formation <br />"Offrir le Québec et les alentours comme destination vacances et introduction au Canada"</strong>
                                    </h4>
                                    <hr />
                                    <mdb-row class="mt-5">
                                        <mdb-col md="6">
                                            <mdb-row class="pb-4">
                                                <mdb-col class="col-12 text-left">
                                                    <p class="text-justify">
                                                        Ce programme de formation permettra d'outiller les conseillers en voyages afin de leur
                                                        permettre d'approfondir leurs connaissances au sujet des différentes offres touristiques
                                                        québécoises et canadiennes tout en les familiarisant avec les techniques et meilleures
                                                        pratiques pour une approche dynamique de contenu sur le web et les médias sociaux.
                                                    </p>
                                                    <p><a href="https://files.expertenvoyages.com/vedformation/public/plan_de_cours.pdf" target="_blank" ><h5 class=""><strong>Voir le plan de cours</strong></h5></a>
                                                    </p>
                                                </mdb-col>
                                            </mdb-row>
                                        </mdb-col>
                                        <mdb-col>
                                            <h3>Se connecter</h3>
                                            <mdb-alert color="danger" v-if="errormsg">
                                                {{errormsg}}
                                            </mdb-alert>
                                            <mdb-input label="Adresse courriel" type="text" class="text-white" v-model="username"/>
                                            <mdb-input label="Mot de passe" type="password" v-model="password"/>

                                            <div class="text-center">
                                                <mdb-btn color="indigo" rounded class="mb-3" v-on:click="login">Connexion</mdb-btn>
                                            </div>
                                            <mdb-row class="d-flex align-items-center">
                                                <div class="text-center col-md-12">
                                                    <a v-on:click="gotolostpassword">J'ai oublié mon mot de passe</a>
                                                </div>
                                                <div class="text-center col-md-12 mt-2">
                                                    <a v-on:click="gotoregister">M'inscrire à la formation</a>
                                                </div>
                                            </mdb-row>
                                        </mdb-col>
                                    </mdb-row>
                                </mdb-card-body>
                            </mdb-card>
                        </mdb-col>
                    </mdb-row>
                </mdb-container>
            </mdb-mask>
        </mdb-view>
    </div>
</template>

<script>
    import {
        mdbBtn,
        mdbInput,
        mdbView,
        mdbMask,
        mdbContainer,
        mdbRow,
        mdbCol,
        mdbCard,
        mdbCardBody,
        mdbAlert,
    } from 'mdbvue';

    import Auth from '../libs/Auth';

    export default {
        name: 'FormsPage',
        data() {
            return {
                username: '',
                password: '',
                errormsg: '',
            };
        },
        components: {
            mdbBtn,
            mdbInput,
            mdbView,
            mdbMask,
            mdbContainer,
            mdbRow,
            mdbCol,
            mdbCard,
            mdbCardBody,
            mdbAlert,
        },
        methods: {
            login() {
                const auth = new Auth();
                auth.login(this.username, this.password).then((result) => {
                    this.errormsg = '';
                    if (result.status === 'OK') {
                        if (this.$store.state.mustcompleteprofile) {
                            this.$router.push({ path: '/profile' });
                        } else {
                            this.$router.push({ path: '/' });
                        }
                    } else {
                        this.errormsg = result.msg;
                        this.password = '';
                    }
                });
            },
            gotolostpassword() {
                this.$router.push({ path: '/lost-password' });
            },
            gotoregister() {
                this.$router.push({ path: '/register' });
            },
        },
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .fullscreen-view{
        height:100vh;
    }
    .intro-2 {
        background: url("/bg2.jpg")
        no-repeat center center;
        background-size: cover;
    }

    .top-nav-collapse {
        background-color: #3f51b5 !important;
    }

    .navbar:not(.top-nav-collapse) {
        background: transparent !important;
    }

    @media (max-width: 768px) {
        .navbar:not(.top-nav-collapse) {
            background: #3f51b5 !important;
        }
    }
    @media (min-width: 800px) and (max-width: 850px) {
        .navbar:not(.top-nav-collapse) {
            background: #3f51b5 !important;
        }
    }

    .rgba-gradient {
        background: -webkit-linear-gradient(
                180deg,
                rgba(22, 91, 231, 0.5),
                rgba(255, 32, 32, 0.5) 100%
        );
        background: -webkit-gradient(
                linear,
                180deg,
                rgba(22, 91, 231, 0.5),
                rgba(255, 32, 32, 0.5) 100%
        );
        background: linear-gradient(
                0deg,
                rgba(22, 91, 231, 0.5),
                rgba(255, 32, 32, 0.5) 100%
        );
    }

    .card {
        background-color: rgba(255, 255, 255, 0.85);
    }

    h6 {
        line-height: 1.7;
    }
</style>
